// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"455":"ef624949","899":"a89b35f4"}[chunkId] + ".chunk.css";
};